<div *ngIf="show" class="loader_background"></div>
<div *ngIf="show" class="loader">
    <mat-spinner [diameter]='50' color='primary'></mat-spinner>
</div>